import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@sara/ui/components/popover';
import { Command, CommandEmpty, CommandItem, CommandList } from '@sara/ui/components/command';
import { Button } from '@sara/ui/components/button';
import { FILTER_REGISTRY } from './registry';
import type { FilterField } from './types';

interface AddFilterMenuProps {
  activeFields: FilterField[];
  onAdd: (field: FilterField) => void;
}

export function AddFilterMenu({ activeFields, onAdd }: AddFilterMenuProps) {
  const [open, setOpen] = useState(false);

  const available = FILTER_REGISTRY.filter((def) => !activeFields.includes(def.field));

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          shape="pill"
          size="sm"
          className="h-7 gap-1 border border-border/70 px-2.5 text-[12.5px] text-muted-foreground hover:text-foreground"
        >
          <Plus className="h-3.5 w-3.5" strokeWidth={1.6} />
          Filter
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-48 p-1">
        <Command>
          <CommandList>
            <CommandEmpty>No filters available.</CommandEmpty>
            {available.map(({ field, label, Icon }) => (
              <CommandItem
                key={field}
                onSelect={() => {
                  setOpen(false);
                  onAdd(field);
                }}
                className="flex items-center gap-2 text-[13px]"
              >
                <Icon className="h-3.5 w-3.5 text-muted-foreground" strokeWidth={1.6} />
                {label}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
